/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PrivateNumberPurchaseDocuments {
  FoundedAnnounce = 0,
  CertificateAddedValue = 1,
  CompanyStatute = 2,
  MinutesCompanyChanges = 3,
  NationalCard = 4,
  BirthCertificate = 5
}
